import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { SlideInterface } from '@tencent/docs-api';

export function preventEdit(target: Object, methodName: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = async function (...args): Promise<SlideInterface.IResult> {
        const appServices = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        if (appServices.viewableServiceLayer.userPriviledgeService.pptEditorState !== PPTEditorStateEnumType.EDITABLE) {
            const { tipsManager } = appServices.viewableServiceLayer;
            tipsManager?.showCannotEditTips();
            return { res: 'fail' };
        }
        return originalMethod?.apply(this, args);
    };

    return descriptor;
}
